import { render, staticRenderFns } from "./DarkCard.vue?vue&type=template&id=03335f70&scoped=true"
import script from "./DarkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DarkCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DarkCard.vue?vue&type=style&index=0&id=03335f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03335f70",
  null
  
)

export default component.exports